<sbnb-signup-wizard-template>
  <ng-container left-side>
    <sbnb-signup-user-header *ngIf="isFirstStep" class="mb-8"></sbnb-signup-user-header>
    <h1 *ngIf="!isFirstStep" class="text-2xl md:text-3xl mb-8">What should we call you?</h1>

    <form [formGroup]="form">
      <div class="flex flex-col md:flex-row gap-0 md:gap-4">
        <div class="flex-1">
          <label class="text-sm font-bold block text-night" for="email">First name</label>
          <mat-form-field class="w-full">
            <input matInput type="text" name="firstName" formControlName="firstName" placeholder="Eg. John" />
            <mat-error *ngIf="form.controls.firstName.errors?.required">
              First name {{ 'CORE.IS_REQUIRED' | transloco }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex-1">
          <label class="text-sm font-bold block text-night" for="lastName" placeholder="Eg. Doe">Last name</label>
          <mat-form-field class="w-full">
            <input matInput type="text" name="lastName" formControlName="lastName" placeholder="Eg. Doe" />
            <mat-error *ngIf="form.controls.lastName.errors?.required">
              Last name {{ 'CORE.IS_REQUIRED' | transloco }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <sbnb-button
        class="block mt-8"
        [fullWidth]="true"
        [loading]="loading"
        [disabled]="form.invalid"
        (clicked)="onContinue()">
        Continue
      </sbnb-button>
    </form>
  </ng-container>

  <sbnb-signup-quick-facts right-side *ngIf="isFirstStep"></sbnb-signup-quick-facts>
  <img right-side *ngIf="!isFirstStep" src="/assets/images/signup/properties-small.svg" />
</sbnb-signup-wizard-template>
